import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Popup, ICommonPopupsProps } from '@gem/popups';
import { Button, customScrollStyles, PopupFooter } from '@gem/ui-kit';

import { AppearanceExample } from '../../components/Appearance/AppearanceExample/AppearanceExample';
import { ChatBackgroundSelection } from '../../components/Appearance/ChatBackgroundSelection/ChatBackgroundSelection';
import { useChatBackgroundPopupPresenter } from './ChatBackgroundPopup.presenter';
import styles from './ChatBackgroundPopup.styles.m.css';

export const ChatBackgroundPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useChatBackgroundPopupPresenter(props);

  return (
    <Popup
      className={styles.popup}
      title={t('chat_appearance')}
      isOpened
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <div className={classNames(styles.container, customScrollStyles.container)}>
        <AppearanceExample previewBackground={presenter.selectedBackground} />

        <ChatBackgroundSelection
          activeChatBackground={presenter.selectedBackground}
          onChatBackgroundChange={presenter.onBackgroundChange}
        />
      </div>

      <PopupFooter>
        <Button
          onClick={presenter.onApply}
          isDisabled={!presenter.hasChanges}
          theme="primary"
        >
          {t('common_apply')}
        </Button>
      </PopupFooter>
    </Popup>
  );
});
